export default [
  {
    path: '',
    component: () => import('@/views/infra/InfraWrapper.vue'),
    children: [
      {
        path: 'infraestructure/menu',
        name: 'infraestructure',
        component: () => import('@/views/infra/Menu.vue'),
      },
      {
        path: 'infraestructure/proposal-process',
        name: 'Announcements',
        component: () => import('@/views/infra/announcements/Main.vue'),
      },
      {
        path: 'infraestructure/proposal-process/generate-letter/:id',
        name: 'GenerateLetter',
        component: () =>
          import('@/views/infra/announcements/AddLetter/Main.vue'),
      },
      {
        path: 'infraestructure/proposal-process/:id/:areaId',
        name: 'ProposalProcess',
        component: () => import('@/views/infra/proposalProcess/Main.vue'),
      },
      {
        path: 'infraestructure/proposal-process/detail/:id',
        name: 'ProposalProcessDetail',
        component: () =>
          import('@/views/infra/proposalProcess/ProponentProfile.vue'),
      },
      {
        path: 'infraestructure/bid-documentation',
        name: 'BidDocumentation',
        component: () => import('@/views/infra/bidDocumentation/Main.vue'),
      },
      {
        path: 'infraestructure/bid-documentation/add',
        name: 'BidDocumentationAdd',
        component: () =>
          import(
            '@/views/infra/bidDocumentation/BidDocumentationManagement.vue'
          ),
      },
      {
        path: 'infraestructure/bid-documentation/edit/:id',
        name: 'BidDocumentationEdit',
        component: () =>
          import(
            '@/views/infra/bidDocumentation/BidDocumentationManagement.vue'
          ),
      },
      {
        path: 'infraestructure/rubric-setting',
        name: 'RubricSetting',
        component: () => import('@/views/infra/rubricSetting/Main.vue'),
      },
      {
        path: 'infraestructure/rubric-add',
        name: 'RubricAdd',
        component: () =>
          import('@/views/infra/rubricSetting/Add/RubricAdd.vue'),
      },
      {
        path: 'infraestructure/rubric-add/:id',
        name: 'RubricEdit',
        component: () =>
          import('@/views/infra/rubricSetting/Add/RubricAdd.vue'),
      },
      {
        path: 'infraestructure/rubric-setting/:id/preview',
        name: 'RubricPreview',
        component: () =>
          import('@/views/infra/rubricSetting/Preview/RubricPreview.vue'),
      },
      {
        path: 'infraestructure/document-configuration',
        name: 'DocumentConfiguration',
        component: () => import('@/views/infra/documentConfiguration/Main.vue'),
      },
      {
        path: 'infraestructure/document-configuration/detail/:id',
        name: 'DocumentConfigurationDetail',
        component: () =>
          import('@/views/infra/documentConfiguration/Detail.vue'),
      },
    ],
  },
];
